import styled from 'styled-components';
import WhyRoundPEBG from '../../../assets/images/WhyRoundPEBG.webp';
import WhyRoundPEOverlayBG from '../../../assets/images/WhyRoundPEOverlayBG.webp';
import WhyRoundPEOverlayVerticalBG from '../../../assets/images/WhyRoundPEOverlayVerticalBG.webp';

export const Container = styled.div`
  background-image: url(${WhyRoundPEBG});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 28px;
  padding-top: 104px;
  padding-bottom: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 104px;
  @media (max-width: 600px) {
    padding-top: 56px;
    padding-bottom: 270px;
    margin-top: 54px;
  }
`;

export const InnerContainer = styled.div`
  width: 80%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  @media (max-width: 600px) {
    font-size: 16px;
    line-height: 21px;
  }
`;

export const Heading = styled.div`
  margin-top: 16px;
  font-weight: bold;
  font-size: 32px;
  line-height: 38px;
  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 29px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 96px;
  flex-wrap: wrap;
  margin-left: -16px;
  margin-right: -16px;
  justify-content: center;
  @media (max-width: 600px) {
    margin-top: 40px;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  max-width: 320px;
  margin-left: 16px;
  margin-right: 16px;
  @media (max-width: 600px) {
    max-width: unset;
  }
`;

export const CardTitle = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  @media (min-width: 600px) {
    min-height: 56px;
  }
`;

export const CardText = styled.div`
  font-size: 16px;
  line-height: 21px;
  margin-top: 19px;
  color: rgba(0, 0, 0, 0.5);
`;

export const CardOverlay = styled.div`
  background-image: url(${WhyRoundPEOverlayBG});
  background-repeat: no-repeat;
  background-size: cover;
  width: 80%;
  align-self: center;
  border-radius: 12px;
  background-position: right 0 center;
  margin-top: -140px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  @media (max-width: 600px) {
    margin-top: -270px;
    background-image: url(${WhyRoundPEOverlayVerticalBG});
    background-size: 100% 100%;
    width: auto;
    margin-left: 28px;
    margin-right: 28px;
  }
`;

export const CardOverlayInnerContainer = styled.div`
  padding: 100px 90px;
  @media (max-width: 600px) {
    padding: 46px 25px;
    padding-bottom: 0;
  }
`;

export const CardOverlayTitle = styled.div`
  font-weight: bold;
  font-size: 32px;
  line-height: 38px;
  color: white;
  max-width: 542px;
  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 29px;
  }
`;

export const CardOverlayText = styled.div`
  font-size: 16px;
  line-height: 21px;
  color: white;
  margin-top: 16px;
  margin-bottom: 21px;
  max-width: 542px;
  @media (max-width: 600px) {
    margin-top: 8px;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const CardOverlayPicture = styled.img`
  display: none;
  @media (max-width: 600px) {
    display: flex;
    width: 90%;
  }
`;

export const StyledButton = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1.1rem 1.6rem 1.1rem 1.82rem;
  width: 14rem;
  gap: 0.625rem;
  background: black;
  border-radius: 0.5rem;
  color: #ffffff;
  font-family: var(--font-family-circular);
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 130%;
  text-align: center;
  border: none;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }
`;
